import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Draft' },
    { value: 2, label: 'Ready to Review' },
    { value: 3, label: 'Ready to Proofread' },
    { value: 4, label: 'Feedback Waiting' },
    { value: 5, label: 'Ready to Publish' },
    { value: 6, label: 'Published' },
    { value: 7, label: 'Void' },
    { value: 8, label: 'Not Applicable' },
  ],
});
